import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Career() { 
  useEffect(() => {
    document.title = 'Career -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li> 
                <li>Career</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Career</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <h5>Career At The Mercy Memorial School</h5>
               <p><b>Note:</b> We would request you to send application very carefully as it will not be possible to modify your application once it has been submitted. In case you do not have all your information with you currently, we would request you to obtain the same before making your application.</p>
               <p> Candidates may apply with a detailed CV (in .doc/.docx/.pdf format only) mentioning their present and expected salary along with a covering letter explaining the candidates suitability for the post.</p> 
               <h5>Vacancy Details  </h5>  <p>Please see the details carefully and apply to join us:  </p>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Career;
